import {
	Breakpoint,
	useBreakpoint,
} from "@gik/core/hooks/hooks/BreakpointHooks";
import { useBemCN } from "@gik/core/utils/bemBlock";
import { UI } from "@gik/ui-legacy/UIManager";
import { LightboxMedia } from "@gik/ui-legacy/UIManager/UILightboxTypes";
import type React from "react";
import type { PhotoProps } from "react-photo-gallery";
import Gallery from "react-photo-gallery";

export interface GalleryPhoto extends PhotoProps {
	caption?: string;
	credit?: string;
}

export interface IImageGalleryProps {
	photos: GalleryPhoto[];
	lightbox?: boolean;
	columns?: number;
}

const blockName = "image-gallery";

export function ImageGallery({
	photos,
	lightbox = false,
	columns = 2,
}: IImageGalleryProps) {
	const bem = useBemCN(blockName);
	const isMd = useBreakpoint(Breakpoint.MD);

	function onGalleryPhotoClicked(
		_: React.MouseEvent,
		{ index: initialSlide }: { index: number },
	) {
		if (lightbox) {
			UI.lightbox(
				photos.map((photo) => ({
					mediaType: LightboxMedia.IMAGE,
					caption:
						`${photo?.caption || ""}${photo?.credit ? " - Credit: " + photo?.credit : ""}`.trim(),
					url: photo?.src,
				})),
				{ title: "Gallery", centeredTitle: true },
				initialSlide,
			);
		}
	}

	return (
		<div {...bem()}>
			<Gallery
				photos={photos.map((photo) => ({
					key: photo?.key,
					src: photo?.src,
					width: photo?.width,
					height: photo?.height,
					alt: photo?.alt,
				}))}
				columns={columns}
				margin={isMd ? 10 : 4}
				onClick={onGalleryPhotoClicked}
				direction={"column"}
			/>
		</div>
	);
}
